<template>
    <v-container>
        <v-layout class="mb-7">
            <v-flex text-center>
                <h2 class="mt-7 mb-3">Vaše objednávka byla úspěšná!</h2>
                <p>Číslo objednávky: {{orderId.orderNumber}}</p>
                <p>O stavu objednávky budete notifikováni na email.</p>
                <v-btn color="primary" depressed tile @click="$router.push('/')">Zpět do obchodu</v-btn>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        name: 'CheckoutSuccess',
        mounted() {
            if (!this.orderId) {
                this.$router.push('/');
            }
        },
        computed: {
            ...mapGetters([
                'orderId'
            ])
        }
    }
</script>
